import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

export default function AuthCallback() {
  const nav = useNavigate();
  const [msg, setMsg] = useState("Completing sign-in…");
  const processed = React.useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) { nav("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", null, { headers: { "X-Session-ID": sessionId }, withCredentials: true });
        if (data?.user_id) {
          // Persist a lightweight marker so AuthContext can refresh user via /me (server verifies session cookie)
          localStorage.setItem("adiyogi_google_user", JSON.stringify(data));
        }
        window.history.replaceState({}, "", "/account");
        window.location.href = "/account";
      } catch (e) {
        setMsg("Sign-in failed. Please try again.");
        setTimeout(() => nav("/login"), 1500);
      }
    })();
  }, [nav]);

  return (
    <div className="container-x py-20 text-center" data-testid="auth-callback">
      <div className="font-serif text-2xl">{msg}</div>
    </div>
  );
}
